import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { useDispatch, useSelector } from 'react-redux';
// material
import { Grid, Container, Stack, Button, CircularProgress, Box } from '@mui/material';

import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink } from 'react-router-dom';
import { nanoid } from 'nanoid';
import InfiniteScroll from 'react-infinite-scroller';
import { ADD_CLASSES, CLASS_OPERATIONS } from '../../../redux/constants';
import Page from '../../../components/Page';

import CardComponent from '../../../components/CardComponent';
import AddClassPopup from '../../../components/AddClassPopup';
import { fetchClasses } from '../../../service/class.service';
import EmptyDashboardChart from '../../../components/EmptyDashboardChart';
import { captureGAEvents } from '../../../analytics/google.analytics';
import { GAEvents } from '../../../analytics/events.constants';
// ----------------------------------------------------------------------
export default function TeacherClasses() {
  const selectedOrg = useSelector((state) => state.org.selectedOrg);
  const orgLoading = useSelector((state) => state.org.orgLoading);
  // Class from redux
  const classesData = useSelector((state) => state.classes.classData);
  // class offset
  const classOffset = useSelector((state) => state.classes.offset);
  // Class has more
  const classHasMore = useSelector((state) => state.classes.hasMore);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(classesData === null);
  const [isAddNewClassPopupOpen, setAddNewClassPopup] = useState(false);
  const [isDataFetching, setIsDataFetching] = useState(false);

  const handleAddNewClass = (classObj) => {
    dispatch({
      type: CLASS_OPERATIONS,
      payload: {
        action: 'add',
        classObj
      }
    });
    setAddNewClassPopup(false);
  };

  const fetchClassList = async () => {
    const orgClasses = await fetchClasses(selectedOrg?.id ?? selectedOrg?.orgId ?? '');
    if (orgClasses) {
      dispatch({
        type: ADD_CLASSES,
        payload: {
          classes: orgClasses.results,
          offset: classOffset + 1
        }
      });
      setIsLoading(false);
    } else {
      // setClassData([]);
      setIsLoading(false);
    }
  };

  const fetchMoreClass = async () => {
    const orgClasses = await fetchClasses(selectedOrg?.id ?? selectedOrg?.orgId ?? '', classOffset);
    if (orgClasses) {
      dispatch({
        type: ADD_CLASSES,
        payload: {
          classes: orgClasses.results,
          offset: classOffset + 1
        }
      });
    }
    setIsDataFetching(false);
  };

  useEffect(() => {
    setIsLoading(classesData === null);
    if (classesData === null && !orgLoading) {
      fetchClassList();
      captureGAEvents(GAEvents.classesScreen, {
        screen: 'teacher_classes'
      });
    } else {
      setIsLoading(false);
    }
  }, [classesData, orgLoading]);

  return (
    <Page title="Classes">
      <Container>
        <>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            alignItems={{ sm: 'center' }}
            justifyContent="end"
            mb={5}
          >
            {/* {classesData !== null && classesData.length > 0 && (
              <Tabs
                value={currentTab}
                onChange={(e, newValue) => setCurrentTab(newValue)}
                variant="scrollable"
                scrollButtons={false}
                aria-label="scrollable prevent tabs example"
              >
                {teacherClassTabOptions.map((t, i) => (
                  <Tab label={t.title} key={i} value={t.title} />
                ))}
              </Tabs>
            )} */}
            <Button
              variant="contained"
              component={RouterLink}
              to="#"
              onClick={() => setAddNewClassPopup(true)}
              startIcon={<Icon icon={plusFill} />}
            >
              Add New Class
            </Button>
          </Stack>
          <Box
            sx={{
              width: `100%`,
              height: `100%`
            }}
          >
            {isLoading && (
              <Box
                sx={{
                  display: 'flex',
                  paddingTop: '25%',
                  justifyContent: 'center',
                  paddingBottom: '25%'
                }}
              >
                <CircularProgress />
              </Box>
            )}
            {!isLoading && classesData !== null && classesData.length > 0 && (
              <InfiniteScroll
                pageStart={0}
                loadMore={() => {
                  if (classHasMore && !isDataFetching) {
                    fetchMoreClass();
                    setIsDataFetching(true);
                  }
                }}
                hasMore={classHasMore}
                loader={
                  <Box mt={4} textAlign="center">
                    <CircularProgress />
                  </Box>
                }
              >
                <Grid container spacing={2} key={nanoid()}>
                  <CardComponent
                    data={[
                      ...classesData.filter((cd) => cd.isUpcoming),
                      ...classesData.filter((cd) => !cd.isUpcoming)
                    ]}
                  />
                </Grid>
              </InfiniteScroll>
            )}
            {!isLoading && classesData !== null && classesData.length === 0 && (
              <div
                style={{
                  display: 'flex',
                  paddingTop: '5%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column'
                }}
              >
                <EmptyDashboardChart text="Oops! No class found" />
              </div>
            )}
          </Box>
          <AddClassPopup
            isOpen={isAddNewClassPopupOpen}
            handleClosePopup={() => setAddNewClassPopup(false)}
            handleAddNewClass={(classObj) => handleAddNewClass(classObj)}
            key={nanoid()}
          />
        </>
        {/* )} */}
      </Container>
    </Page>
  );
}
